import React from 'react'
import { Box, Tooltip } from '@mui/material'

import { Avatar, type AvatarSize, Chip, Typography } from '~components/internal'

import './ContactList.scss'

export interface Contact {
  name: string
  image?: string | null
}

export interface ContactListProps {
  contacts: Contact[]
  avatarSize?: AvatarSize
}

const ContactList: React.FC<ContactListProps> = ({ contacts, avatarSize = 'sm' }) => {
  if (contacts.length === 0) return null

  const [first, ...rest] = contacts

  return (
    <Box className='contact-list'>
      <Box className='contact-list__contact'>
        <Avatar src={first.image ?? undefined} alt={first.name} size={avatarSize} />
        <Typography variant='body2'>{first.name}</Typography>
      </Box>
      {rest.length > 0 && (
        <Tooltip title={rest.map((contact) => contact.name).join(', ')}>
          <span>
            <Chip
              className='contact-list__overflow'
              size='small'
              variant='outlined'
              color='neutral'
              label={`+${rest.length}`}
            />
          </span>
        </Tooltip>
      )}
    </Box>
  )
}

export default ContactList
